import axios from "axios";
import {IAudiobook, IStatLicenses} from "../models/audiobook";
class AudiobookService {
  public static async getAudiobook(audiobookId: string): Promise<IAudiobook> {
    const audiobookData = await axios
      .get(`audiobooks/${audiobookId}`)
    return audiobookData.data.data
  }

  public static async postLicenses(findawayId: string): Promise<IStatLicenses> {
    const audiobookData = await axios.post(`licenses`, {
      "licenses": {
        "book_id": findawayId
      }
    })
    return audiobookData.data.data
  }

}
export default AudiobookService
